import PropTypes from 'prop-types';
import './Toggle.css';

/**
 * Reusable Toggle Switch Component
 * Accessible toggle switch for binary states
 */
const Toggle = ({
  checked = false,
  onChange,
  disabled = false,
  className = '',
  id,
  name,
  ...props
}) => {
  const toggleClass = `toggle-switch ${className}`;
  const inputClass = 'toggle-input';
  const sliderClass = 'toggle-slider';

  return (
    <label className={toggleClass}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={inputClass}
        id={id}
        name={name}
        {...props}
      />
      <span className={sliderClass}></span>
    </label>
  );
};

Toggle.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
};

export default Toggle;
